import React, { Component } from 'react';
import { Box,IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { MoreVertRounded, QrCode2Rounded } from '@mui/icons-material';
import { isEmpty } from 'lodash';
import { green, red } from '@mui/material/colors';
import Articles from '../Forms/Articles';
import Currency from '../../../common/Currency';
import ArticlePics from '../Forms/ArticlePics';
// import ArticlePics from '../Forms/ArticlePics';


class ArticleList extends Component {
    state = { 
        type: "",
        selected: {},
        openFilters: false,
        openUpdate: false,
        openUpdatePics: false,
        anchorEl: null, 
        openMenu: "", 
        deleteArticle: false, 
        toDelete: {},
    }

    handleOpenUpdate = (data, form = "openUpdate", open = true) => {
        this.setState({
			selected: data ,
            [form]: open,
            openMenu: "",
            anchorEl: null
		})
    }

    render() {
        const { selected, openUpdate, openUpdatePics, anchorEl, openMenu } = this.state;
        const { ARTICLES } = this.props
        return (
            <Box>
                
                {openUpdate && !isEmpty(selected) &&
                    <Articles
                        update
                        article={this.state.selected}
                        {...this.props}
                        handleClose={() => this.handleOpenUpdate({}, "openUpdate", false)}
                    />
                }
                {openUpdatePics && !isEmpty(selected) &&
                    <ArticlePics
                        update
                        article={this.state.selected}
                        type={this.state.selected.article_type}
                        {...this.props}
                        handleClose={() => this.handleOpenUpdate({}, "openUpdatePics", false)}
                    />
                }
                <Box p={1}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Intitulé</TableCell>
                                <TableCell>Marque</TableCell>
                                <TableCell>Prix</TableCell>
                                <TableCell>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isEmpty(ARTICLES)  && Object.values(ARTICLES).map(article =>                                
                                <TableRow >
                                    {/* <TableCell className="a-like" onClick={() => this.props.handleSingle(article)}>{article.article_name}</TableCell>  */}
                                    <TableCell>{article.article_name}</TableCell> 
                                    <TableCell>{article.article_brand}</TableCell>
                                    <TableCell><Currency value={article.article_price} /></TableCell>
                                    <TableCell>
                                        <>
                                            <IconButton 
                                                aria-controls={`option-menu${article.article_id}`} 
                                                aria-haspopup="true"
                                                onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : article.article_id}) }>
                                                <MoreVertRounded />
                                            </IconButton>

                                            <Menu
                                                MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                                }}
                                                id={`option-menu${article.article_id}`}
                                                anchorEl={anchorEl}                                               
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                open={ openMenu === article.article_id}
                                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                                            >
                                                <MenuItem onClick={() => this.handleOpenUpdate(article) } >Modifier</MenuItem>                
                                                <MenuItem onClick={() => this.handleOpenUpdate(article, "openUpdatePics") } >Modifier Photos</MenuItem>                
                                                {/* <MenuItem 
                                                    onClick={() => this.setState({ 
                                                        deleteArticle: true, 
                                                        toDelete: article, 
                                                        openMenu: "", 
                                                        anchorEl:null
                                                    }) }
                                                >
                                                    Supprimer
                                                </MenuItem> */}
                                            </Menu>
                                        </>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
                
        );
    }
}

export default ArticleList;